import { GET, POST } from 'clients/Clients';

// MOCK API
const upload = async ({ ctx, body }) =>
  POST({
    ctx,
    url: '/upload',
    mock: true,
    body,
  });

const uploadWithoutAuth = async ({ ctx, body, isAuth }) =>
  POST({
    ctx,
    url: '/upload',
    mock: true,
    body,
    isAuth,
  });

const uploadFeedbackMock = async ({ ctx, body }) =>
  POST({
    ctx,
    url: '/upload/feedback',
    mock: true,
    isAuth: false,
    body,
  });

// SERVER API
const genTokenNoAuth = async ({ ctx }) =>
  GET({
    ctx,
    url: '/core/file-manager/v1/access-token/gen',
    isBasic: true,
    isAuth: false,
  });

const genToken = async ({ ctx }) =>
  GET({
    ctx,
    url: '/core/file-manager/v1/access-token/gen',
  });

const uploadDocument = async ({ ctx, body }) =>
  POST({
    ctx,
    url: '/core/file-manager/v1/upload/document',
    body,
    isBasic: true,
  });

const uploadFileImage = async ({ ctx, body }) =>
  POST({
    ctx,
    url: '/core/file-manager/v1/upload/image',
    body,
    isBasic: true,
  });

export default {
  upload,
  uploadWithoutAuth,
  uploadFeedbackMock,
  genTokenNoAuth,
  genToken,
  uploadDocument,
  uploadFileImage,
};
